module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"confirmEmail":"Подтверждение адреса электронной почты","confirmingEmail":"Подтверждаем E-mail адрес","notConfirmed":"Не удалось подтвердить E-mail адрес","resend":"Отправить письмо заново","verificationSent":"Письмо для подтверждения E-mail отправлено"}}')
  delete Component.options._Ctor
}
